<script>
    export let path = '';


    let paths = [];
    let lastTitle = '';

    // recomputed whenever `path` changes (e.g. translated titles after a language switch)
    $: {
        paths = [];
        let sett = path.split(';');
        let lastUrl = '#';
        lastTitle = '';
        for(let p of sett)
        {
            if(!p||!p.trim())continue;
            let st = p.split('=>');
            lastUrl = (st[0]||'').trim();
            lastTitle = (st[1]||'').trim();
            paths.push({url: lastUrl, title: lastTitle});
        }

        if(paths.length) paths[0].first = true;
        if(paths.length) paths[paths.length-1].last = true;
    }

</script>


<h5 class="content-header-title float-left pr-1 mb-0">{lastTitle}</h5>
<div class="breadcrumb-wrapper col-12">
    <ol class="breadcrumb p-0 mb-0">
        <li class="breadcrumb-item"><a href="#/"><i class="bx bx-home-alt"></i></a></li>
        {#each paths as p}
            <li class="breadcrumb-item" class:active={p.last}><a href="#/{p.url}">{p.title}</a></li>
        {/each}
    </ol>
</div>